import type { CSSProperties } from 'react';
import type { ButtonProps } from '../../types';
import { ACCENT, BORDER_LIGHT, EASE, TEXT_PRIMARY } from '../../tokens';

/** Secondary outlined CTA. */
export function BtnOutline({ href = '#', onClick, children, style = {}, target }: ButtonProps) {
  const base: CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    background: 'transparent',
    color: TEXT_PRIMARY,
    textDecoration: 'none',
    padding: '12px 28px',
    borderRadius: 100,
    fontSize: '0.8rem',
    fontWeight: 500,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    border: `1px solid ${BORDER_LIGHT}`,
    cursor: 'pointer',
    transition: `all 0.3s ${EASE}`,
    ...style,
  };

  return (
    <a
      href={href}
      onClick={onClick}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      style={base}
      onMouseEnter={(e) => {
        const el = e.currentTarget;
        el.style.borderColor = ACCENT;
        el.style.color = ACCENT;
        el.style.boxShadow = '0 0 20px rgba(255,107,0,0.15)';
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget;
        el.style.borderColor = BORDER_LIGHT;
        el.style.color = TEXT_PRIMARY;
        el.style.boxShadow = 'none';
      }}
    >
      {children}
    </a>
  );
}
